import { clearRowFilter, readRowFilter, writeRowFilter } from '../../domain/rowFilter.js';
import { useUrlFilter } from '../../hooks/useUrlFilter.js';

/** A grid's filter, held in the URL (`domain/rowFilter.ts`), over the shared `useUrlFilter`. */
export const useRowFilter = () => useUrlFilter(readRowFilter, writeRowFilter, clearRowFilter);
